/**
 * Cosine similarity from a cosine-distance score, clamped to [0, 1].
 * `rmi-topic-tree` uses cosine, so this is the right metric for the
 * default plugin; other plugins may use euclidean, in which case the
 * value is still a useful "lower distance is better" indicator but no
 * longer a true similarity. We surface it as a percentage either way.
 */
export const distanceToSimilarityPercent = (distance: number): number => {
  const sim = 1 - distance;
  if (Number.isNaN(sim)) return 0;
  if (sim < 0) return 0;
  if (sim > 1) return 100;
  return Math.round(sim * 100);
};

export const similarityColor = (percent: number): string => {
  if (percent >= 85) return "teal";
  if (percent >= 65) return "yellow";
  return "red";
};

/**
 * Colour bands for the category ("key") match score. Looser thresholds
 * than `similarityColor` — a domain-level agreement of 70%+ is already a
 * strong signal — mirroring the reference prototype's cat-score bands.
 */
export const categoryScoreColor = (percent: number): string => {
  if (percent >= 70) return "teal";
  if (percent >= 40) return "yellow";
  return "red";
};

/**
 * Color the raw distance directly (lower = better). Mirrors the
 * 85% / 65% similarity bands but expressed against cosine distance
 * (1 - similarity).
 */
export const distanceColor = (distance: number): string => {
  if (distance <= 0.15) return "teal";
  if (distance <= 0.35) return "yellow";
  return "red";
};

